

import React, { Component } from "react";
import axios from 'axios';
import "./App.css";
import Main from "./main";
// import About from "./about";
import Projects from "./projects";
import Contact from "./contact";

class App extends Component {

  componentDidMount() {

    var formatter = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'Asia/Singapore',
      formatMatcher: 'basic'
    });

    var url = `https://api.telegram.org/bot${process.env.REACT_APP_TOKEN}/sendMessage`;
    var msg = `${formatter.format(new Date())}, Personal Website`
    var params = { chat_id: process.env.REACT_APP_CHAT_ID, text: msg };

    axios.get(url, { params: params })
      .then(res => {
        console.log(res.data)
      })
  }

  render() {

    return (

      
      <div>

        <section><div className="top-container"><Main /></div></section>
        {/* <div className="top-container reveal" ><InternalLinks style={{position: "sticky", top: "0"}} /></div> */}
        {/* <section><div className="middle-container reveal"><About /></div></section> */}
        <section><div className="bottom-container"><Projects /></div></section>
        <section><div className="bottom-container"><Contact /></div></section>
        {/* <section><div className="bottom-container reveal"><End /></div></section> */}

        <script>
          sendMessage("Website accessed")
          console.log(token)
        </script>

      </div>

    );

  }

}

export default App;